import api from './api';

export const listTickets = async (params = {}) => {
  const res = await api.get('/support', { params });
  return res.data;
};

export const updateTicketStatus = async (id, status) => {
  const res = await api.patch(`/support/${id}`, { status });
  return res.data;
};

export const respondToTicket = async (id, message, status) => {
  const res = await api.post(`/support/${id}/respond`, { message, status });
  return res.data;
};

export const exportTicketsCsv = async (params = {}) => {
  const res = await api.get('/support/export/csv', { params, responseType: 'blob' });
  return res.data; // Blob
};

